import React, { ReactNode } from 'react';
import { DateField, EditButton, TextField } from 'react-admin';
import CustomizableGrid from '../components/CustomizableGrid';
import { ColumnConfig } from '../hooks/useColumnReorder';

const DeliveryPartnerList = ({ permissions = [], ...props }) => {
    const defaultColumns: ColumnConfig[] = [
        { id: 'id', label: 'ID', visible: true, order: 0 },
        { id: 'name', label: 'Name', visible: true, order: 1 },
        { id: 'createdAt', label: 'Created At', visible: true, order: 2 },
        { id: 'updatedAt', label: 'Updated At', visible: false, order: 3 },
        { id: 'edit', label: 'Edit', visible: true, order: 4 },
    ];

    const renderColumn = (columnId: string): ReactNode => {
        switch (columnId) {
            case 'id':
                return <TextField key={columnId} source="id" />;
            case 'name':
                return <TextField key={columnId} source="name" />;
            case 'createdAt':
                return (
                    <DateField
                        key={columnId}
                        source="createdAt"
                        label="Created At"
                    />
                );
            case 'updatedAt':
                return (
                    <DateField
                        key={columnId}
                        source="updatedAt"
                        label="Updated At"
                        showTime
                    />
                );
            case 'edit':
                return <EditButton key={columnId} />;
            default:
                return null;
        }
    };

    const combinedProps = {
        title: 'Delivery Partners',
        permissions,
        defaultColumns,
        storageKey: 'deliveryPartnerListColumns',
        renderColumn,
        sort: { field: 'id', order: 'DESC' },
        ...props,
        resource: props.resource || 'delivery-partners',
        location: props.location || { search: '' },
        hasShow: props.hasShow !== undefined ? props.hasShow : false,
        hasEdit: props.hasEdit !== undefined ? props.hasEdit : true,
    };

    return <CustomizableGrid {...combinedProps} />;
};

DeliveryPartnerList.defaultProps = {
    resource: 'delivery-partners',
    location: { search: '' },
};

export default DeliveryPartnerList;
